module.exports = function() {
  return new Worker(__webpack_public_path__ + "8606e8214557121aebcb.worker.js");
};